/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { noop } from 'lodash'
import { useIntl } from 'react-intl'

import {
  EuiText,
  EuiDescribedFormGroup,
  EuiFormRow,
  EuiSwitch,
  EuiCard,
  useEuiTheme,
} from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

const SetDefaultTrustServerless = (): JSX.Element => {
  const { euiTheme } = useEuiTheme()
  const { formatMessage } = useIntl()

  return (
    <EuiCard
      hasBorder={true}
      title={<span />}
      betaBadgeProps={{
        label: formatMessage({
          defaultMessage: 'Coming soon',
          id: 'trust-management.default-trust-beta-badge',
        }),
      }}
      style={{ textAlign: 'left', backgroundColor: euiTheme.colors.backgroundBaseSubdued }}
    >
      <EuiDescribedFormGroup
        style={{
          flexDirection: 'column',
        }}
        title={
          <strong>
            <FormattedMessage
              id='trust-management.default-trust-title-serverless'
              defaultMessage='Serverless project'
            />
          </strong>
        }
        titleSize='xxs'
        description={
          <FormattedMessage
            id='trust-management.default-trust-description-serverless'
            defaultMessage='Select the default trust level between new projects and other projects of this organization.'
          />
        }
      >
        <EuiFormRow
          helpText={
            <EuiText css={{ paddingLeft: 53 }}>
              <FormattedMessage
                id='trust-management.default-trust-text-serverless'
                defaultMessage='This configuration also includes future projects.'
              />
            </EuiText>
          }
        >
          <EuiSwitch
            label={
              <FormattedMessage
                id='trust-management.default-trust-switch-label'
                defaultMessage='Trust all projects'
              />
            }
            onChange={() => noop()}
            checked={true}
            disabled={true}
          />
        </EuiFormRow>
      </EuiDescribedFormGroup>
    </EuiCard>
  )
}

export default SetDefaultTrustServerless
